var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.recom_customers-all'),"text":_vm.$t('recom_users.description'),"name":"customers","url":_vm.$listRoutes.recomCustomers,"table":_vm.customers,"filters":_vm.customersFilters,"fields":_vm.fields,"search":true,"defaultFilters":_vm.defaultCreatedAtFilter,"requireFilters":true,"useCurrency":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }